export const arrayRemove = (array, index, count = 1) => {
    if (index < 0 || index >= array.length)
        return array.concat();
    const newArray = array.concat();
    newArray.splice(index, count);
    return newArray;
};
